import { useEffect } from "react";
import { Link } from "react-router";

import Logo from "../assets/images/Logo.svg";
import NDIS from "../assets/images/ndislogo.webp";

const Footer = () => {
  useEffect(() => {
    const backToTopBtn = document.querySelector(".backToTop");
    if (backToTopBtn) {
      const handleClick = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      };
      backToTopBtn.addEventListener("click", handleClick);
      return () => {
        backToTopBtn.removeEventListener("click", handleClick);
      };
    }
  }, []);

  return (
    <footer className="bg-white text-purple">
      <div className="mx-auto max-w-7xl px-2">
        <div className="mx-4 grid grid-cols-1 gap-12 pt-12 sm:grid-cols-2 md:grid-cols-4">
          {/* Logo and Acknowledgement */}
          <div className="order-4 flex flex-col sm:order-3 md:order-1">
            <div className="flex flex-row justify-center gap-4">
              <img src={Logo} className="w-1/3 sm:w-[40%]" alt="Provido Logo" />
              <img
                src={NDIS}
                className="w-1/2 sm:w-2/3"
                alt="NDIS Registered Provider"
              />
            </div>
            <div className="pt-4 text-center text-xs text-gray-500">
              Provido acknowledges the Traditional Owners and Custodians of the
              land on which we work, and we pay respect to Elders past, present
              and emerging.
            </div>
          </div>

          {/* Links */}
          <div className="order-2 text-center sm:order-1 sm:text-left md:order-2">
            <span className="text-teal font-display text-lg">Links</span>
            <div className="mt-2 flex flex-col gap-2">
              <Link to="/" className="link-list">
                Home
              </Link>
              <Link to="/about" className="link-list">
                About
              </Link>
              <Link to="/contact" className="link-list">
                Contact
              </Link>
            </div>
            <div className="mt-6 flex flex-col gap-2">
              <Link to="/contact/complaints" className="link-list">
                Lodge a Complaint
              </Link>
            </div>
          </div>

          {/* Services */}
          <div className="order-1 text-center sm:order-2 sm:text-left md:order-3">
            <span className="text-teal font-display text-lg">Services</span>
            <div className="mt-2 flex flex-col gap-2">
              <Link
                to="/services/support-with-daily-living"
                className="link-list"
                title="Support with Daily Living"
              >
                Support with Daily Living
              </Link>
              <Link
                to="/services/community-access"
                className="link-list"
                title="Community Access"
              >
                Community Access
              </Link>
              <Link
                to="/services/nursing"
                className="link-list"
                title="Nursing"
              >
                Nursing
              </Link>
              <Link
                to="/services/transport"
                className="link-list"
                title="Transport"
              >
                Transport
              </Link>
              <Link
                to="/services/exercise-physiology"
                className="link-list"
                title="Exercise Physiology"
              >
                Exercise Physiology
              </Link>
              <Link
                to="/services/supported-independent-living"
                className="link-list"
                title="Supported Independent Living"
              >
                Supported Independent Living
              </Link>
            </div>
          </div>

          {/* Contact Details */}
          <div className="order-3 text-center sm:order-4 sm:text-left md:order-4">
            <span className="text-teal font-display text-lg">Contact Us</span>
            <div className="mt-2 flex flex-col gap-2">
              <a href="tel:0348319551" className="link-list">
                03 4831 9551
              </a>
              <a href="mailto:contact@provido.com.au" className="link-list">
                contact@provido.com.au
              </a>
              <span className="link-list-text">Monday to Friday 8am–5pm</span>
            </div>
            <div className="mt-2 flex flex-row justify-center gap-2 sm:justify-start">
              <a
                href="https://www.facebook.com/profile.php?id=61590094256989"
                target="_blank"
                title="Facebook"
              >
                <span className="ph size-6 ph-[facebook-logo]"></span>
              </a>
              <a
                href="https://www.instagram.com/_provido/"
                target="_blank"
                title="Instagram"
              >
                <span className="ph size-6 ph-[instagram-logo]"></span>
              </a>
            </div>
          </div>
        </div>
        {/* Copyright and Back to Top Link */}
        <div className="mx-4 flex flex-row justify-between py-12 font-body text-xs text-purple/80">
          &copy; 2026 Provido | ABN: 59 675 592 346 | NDIS Provider Number:
          4053359683 | Registered with TAC
          <a href='#' className="backToTop hover:cursor-pointer">Back to Top</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
